import React, { useState, useEffect } from "react";

//API
import api from "../services/api";

import Box from "../components/Box";

//Icons
import { Edit } from "react-feather";
import { Input } from "../components";
import { useForm } from "react-hook-form";
import { useAuth } from "../providers/auth";

//Momentjs
import moment from "moment";
import "moment/locale/pt-br";

import useAxios from "../hooks/useAxios";
import axiosInstance from "../apis/gvmdesk";
import LoadingCenter from "../components/LoadingCenter";

export const Profile = () => {
  const { user } = useAuth();
  const { register, formState: { errors } } = useForm();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [calls, setCalls, callsLoading, callsError, refetchCalls] = useAxios({
    axiosInstance,
    method: "GET",
    url: "/calls/last"
  });

  async function fetchUserAccountData() {
    try {
      const { data } = await api.get("/admins", { headers: { "Authorization": "Bearer " + user.token } });

      setData(data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchUserAccountData();
  }, []);

  return (
    <div className="inner-profile">
      {loading && <LoadingCenter />}

      {!loading && <div className="profile-form">
        <div className="profile-avatar" style={{ backgroundImage: `url(${data.profile_picture})` }}>
          <div className="avatar-absolute-div">
            <button type="file" className="photo-edit-btn">
              <Edit size={24} />
            </button>
          </div>
        </div>

        <div>
          <Input disabled={true} label="Nome completo" value={data.name} name="name" register={register} />

          <Input disabled={true} label="E-mail" type="email" value={data.email} name="email" register={register} />

          <Input disabled={true} label="Grupo" value={data.group_name} name="group" register={register} />

          <Input disabled={true} label="Data de admissão" value={moment(data.create_time).format("LL")} name="admission_date" register={register} />
        </div>

        <div className="btn-save-profile">
          {/* <Button title="Salvar alterações" type="submit" color="green" width="full" loading={false} onClick={() => { }} /> */}
        </div>

        <Box title="Histórico de ligações">
          <div>
            <ul className="doc__list">
              <li className="doc__item mb-10 d-flex flex-row align-center u-justify-between border-bottom">
                <span className="doc__name f-w-500" style={{ width: "75%" }}>Nome</span>
                <span className="doc__name f-w-500" style={{ width: "25%" }}>Data/hora</span>
              </li>
              {calls?.map(call => {
                return (
                  <li className="doc__item mb-10 d-flex flex-row align-center u-justify-between">
                    <span className="doc__name" style={{ width: "75%" }}>{call.name}</span>
                    <span className="doc__name" style={{ width: "25%" }}>{moment(call.data).format("L")}</span>
                  </li>
                );
              })}
            </ul>
          </div>
        </Box>

      </div>}
    </div>
  );
}

export default Profile;